import { render, staticRenderFns } from "./ControlGroupInfo.vue?vue&type=template&id=ed1d8ff0&scoped=true"
import script from "./ControlGroupInfo.vue?vue&type=script&lang=js"
export * from "./ControlGroupInfo.vue?vue&type=script&lang=js"
import style0 from "./ControlGroupInfo.vue?vue&type=style&index=0&id=ed1d8ff0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed1d8ff0",
  null
  
)

export default component.exports